import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import SelectHotlistRecipientsDialog from './SelectHotlistRecipientsDialog.vue';

interface SelectRecipientsProps {
  callId: string;
  value: number[];
  clientId: number;
  hotlistId: number;
  allRecipients: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectRecipients',
  props: {
    callId: null,
    value: { default: () => [] },
    clientId: null,
    hotlistId: null,
    allRecipients: { default: () => [] }
  },
  emits: ["recipients-updated"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'recipients-updated'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { callId: string, value: number[], clientId: number, hotlistId: number, allRecipients: any[] }





const items = computed(() => props.allRecipients.filter((item) => item.CLIENT_ID === props.clientId));

const selectedHotlistRecipients = computed(() =>
  items.value.map((item) => (item.FULL_NAME.trim() === 'Company' ? 'Company Email' : item.FULL_NAME.trim())).join(', ')
);

const showDialog = ref(false);

return { __sfc: true,props, emit, items, selectedHotlistRecipients, showDialog, SelectHotlistRecipientsDialog }
}

})